import {
  SortCriterion,
  SortOrder,
  buildFieldSortCriterion,
  buildRelevanceSortCriterion,
} from '@coveo/atomic-react';
import { CoveoSearchHub } from '@lib/coveo/coveoConstants';

export const RELEVANCE_SORT = {
  value: 'relevance',
  criterion: buildRelevanceSortCriterion(),
};
export const POPULARITY_SORT = {
  value: 'popularity',
  criterion: buildRelevanceSortCriterion(),
};

export const SEARCH_SORT_CRITERIA: {
  value: string;
  criterion: SortCriterion;
}[] = [
  RELEVANCE_SORT,
  POPULARITY_SORT,
  {
    value: 'rating',
    criterion: buildFieldSortCriterion('ec_rating_sort', SortOrder.Descending),
  },
  {
    value: 'published-date',
    criterion: buildFieldSortCriterion(
      'first_published_at',
      SortOrder.Descending
    ),
  },
  {
    value: 'recently-updated',
    criterion: buildFieldSortCriterion(
      'last_published_at',
      SortOrder.Descending
    ),
  },
  {
    value: 'price-low-to-high',
    criterion: buildFieldSortCriterion('ec_price_filter', SortOrder.Ascending),
  },
  {
    value: 'price-high-to-low',
    criterion: buildFieldSortCriterion('ec_price_filter', SortOrder.Descending),
  },
];

export const LISTING_SORT_CRITERIA: {
  value: string;
  criterion: SortCriterion;
}[] = [
  POPULARITY_SORT,
  {
    value: 'rating',
    criterion: buildFieldSortCriterion('ec_rating_sort', SortOrder.Descending),
  },
  {
    value: 'published-date',
    criterion: buildFieldSortCriterion(
      'first_published_at',
      SortOrder.Descending
    ),
  },
  {
    value: 'recently-updated',
    criterion: buildFieldSortCriterion(
      'last_published_at',
      SortOrder.Descending
    ),
  },
  {
    value: 'price-low-to-high',
    criterion: buildFieldSortCriterion('ec_price_filter', SortOrder.Ascending),
  },
  {
    value: 'price-high-to-low',
    criterion: buildFieldSortCriterion('ec_price_filter', SortOrder.Descending),
  },
];

export const getSortCriteriaForSearchHub = (searchHub: string | undefined) => {
  if (searchHub === CoveoSearchHub.SEARCH) {
    return SEARCH_SORT_CRITERIA;
  }
  return LISTING_SORT_CRITERIA;
};
